import React from 'react'
import * as Util from './Util'
import '../../css/devices.min.css'
import '../../css/iphone.css'

export const IPhoneX=props=>{
  return (
    <div className="marvel-device iphone-x">
      <div className="notch">
        <div className="camera"></div>
        <div className="speaker"></div>
      </div>
      <div className="top-bar"></div>
        <div className="sleep"></div>
        <div className="bottom-bar"></div>
        <div className="volume"></div>
        <div className="overflow">
        <div className="shadow shadow--tr"></div>
        <div className="shadow shadow--tl"></div>
        <div className="shadow shadow--br"></div>
        <div className="shadow shadow--bl"></div>
      </div>
      <div className="inner-shadow"></div>
      <div className="screen">
        {props.children}
      </div>
    </div>
  )
}

export const IPhone8=props=>{
  return (
    <div className="marvel-device iphone8 silver">
      <div className="top-bar"></div>
      <div className="sleep"></div>
      <div className="volume"></div>
      <div className="camera"></div>
      <div className="sensor"></div>
      <div className="speaker"></div>
      <div className="screen">
        {props.children}
      </div>
      <div className="home"></div>
      <div className="bottom-bar"></div>
    </div>
  )
}

export const colors = ['white','black']

export const IPhone5=(props={})=>{
  let {color} = props
  if (!Util.isValid(color,colors)) {
    color = Util.randomFrom(colors)
  }
  return (
    <div className={`md-iphone-5 md-${color}-device md-glare`}>
       <div className="md-body">
        <div className="md-buttons"></div>
        <div className="md-front-camera"></div>
        <div className="md-top-speaker"></div>
        <div className="md-screen">
          {props.children}
        </div>
        <button className="md-home-button"></button>
      </div>
    </div>
  )
}

const Frame={
  IPhoneX: IPhoneX,
  IPhone8: IPhone8,
  IPhone5: IPhone5,
}
export default Frame



// WEBPACK FOOTER //
// ./src/component/util/Frame.js